import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "question-content-show" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = {
  xs12: "",
  class: "body-padding-top-0px"
}

import { ref, computed, watch, onMounted } from 'vue'
import Question from '../models/Question'
import { LETTER_FORMAT } from '../../client/utils/constants'
import { questionServiceParser } from '../../../helpers/question-parser'
import QuestionRadio from '../../client/components/atoms_molecules/QuestionRadio.vue'
import QuestionCheckBox from '../../client/components/atoms_molecules/QuestionCheckBox.vue'
import QuestionSelect from '../../client/components/atoms_molecules/QuestionSelect.vue'
import Simplemde from '../../client/components/atoms_molecules/Simplemde.vue'

import { resetStyleMathLive, checkMathLiveExist, createMathliveField } from '../../../lib/mathlive'
import { processAudioSpeak } from '../../../lib/speak_polly'
import Exam from "../../api/v2/models/exam"


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionBodyComponent',
  props: {
    question: {},
    isAnswered: { type: Boolean, default: false },
    questionNumber: { default: 1 },
    totalQuestionNumber: { default: 10 },
    totalQuestion: { default: 1 },
    exam: {}
  },
  emits: ["onAnswer"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const reRender = ref(Date().toString())
// Ref points to the <v-card> component instance; .$el is its root DOM element.
const questionCard = ref<any>(null)
const getContainer = (): HTMLElement | null => questionCard.value?.$el ?? questionCard.value ?? null
const text = ref('')
const value = ref<string[]>([])
const time = ref(20)
const score = ref(0)
const totalScore = ref(0)
const height = ref(200)

const radioValue = computed(() => {
  return value.value.length ? value.value[0] : ''
})

// Answer-input area only renders for these question types.
// textfield / inline-select embed their inputs in the question body (v-html),
// so the dedicated answer area would be empty for them.
const hasAnswerInput = computed(() => {
  const q = props.question
  return q.isTextarea || q.isCheckbox || q.isMultiCheckbox || q.isRadio || q.isSelect
})

watch(() => props.question, () => {
  text.value = ''
  value.value = []
  if (props.question.answerItems.length >= 3) {
    height.value = 200 + props.question.answerItems.length * 20
  } else {
    height.value = 200
  }
  if (props.questionNumber == props.totalQuestion) {
    height.value = height.value + props.question.answerItems.length * 30
  }
})

const content = computed(() => {
  if (!props.question) {
    return ''
  }
  setTimeout(() => {
    const container = getContainer()
    if (!container) return

    if (props.question.isTextfield) {
      const textfieldElements = container.querySelectorAll<HTMLInputElement>('.textfield-question')
      textfieldElements.forEach((element, index) => {
        element.value = value.value[index] || ''

        const answerItem = props.question.answerItems[index]
        if (answerItem && checkMathLiveExist(answerItem.body)) {
          createMathliveField(element)
        }
      })
    }

    // Text - Speak 実行
    processAudioSpeak(container, true)
  }, 100)
  return questionServiceParser(props.question.questionBody, props.question, true)
})

onMounted(() => {
  resetStyleMathLive()
  if (props.questionNumber == props.totalQuestion) {
    height.value = height.value + props.question.answerItems.length * 30
  }
})

const callBackChange = (newValue: string[]) => {
  value.value = newValue
}

const callBackChangeOne = (a: string) => {
  value.value = [a]
}

watch(() => props.isAnswered, () => {
  if (!props.isAnswered) {
    return
  }

  const container = getContainer()
  if (!container) return

  if (props.question.isTextfield) {
    const textfieldElements = container.querySelectorAll('.textfield-question')
    value.value = []
    for (let index = 0; index < textfieldElements.length; index++) {
      value.value.push((textfieldElements[index] as HTMLInputElement).value)
    }
  }

  if (props.question.isInlineSelect) {
    const inlineSelectElements = container.querySelectorAll('.inline-select-question')
    value.value = []
    for (let index = 0; index < inlineSelectElements.length; index++) {
      value.value.push((inlineSelectElements[index] as HTMLInputElement).value)
    }
  }

  if (props.question.isTextarea && text.value) {
    value.value = [text.value]
  }

  totalScore.value = props.question.getTotalScore()
  if (!value.value || value.value.length === 0) {
    emit('onAnswer', 0, totalScore.value)
    return
  }

  score.value = props.question.getScore(value.value)
  emit('onAnswer', score.value, totalScore.value)
})

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    ref_key: "questionCard",
    ref: questionCard,
    class: "question-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card_title, { class: "title-padding-bottom-0px" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "question-body-preview-client subheading",
                innerHTML: content.value
              }, null, 8 /* PROPS */, _hoisted_2)
            ])
          ]),
          _: 1 /* STABLE */
        }),
        (hasAnswerInput.value)
          ? (_openBlock(), _createBlock(_component_v_card_title, {
              key: 0,
              class: "title-padding-top-0px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (__props.question.isTextarea)
                      ? (_openBlock(), _createBlock(Simplemde, {
                          key: 0,
                          name: `markdownEditor_q_${__props.question.id}`,
                          ref: `markdownEditor_q_${__props.question.id}`,
                          modelValue: text.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
                          rows: __props.question.textareaRowNumber,
                          readonly: time.value === 0 || __props.isAnswered,
                          "preview-class": "markdown-body",
                          class: "w-100"
                        }, null, 8 /* PROPS */, ["name", "modelValue", "rows", "readonly"]))
                      : (__props.question.isCheckbox || __props.question.isMultiCheckbox)
                        ? (_openBlock(), _createBlock(QuestionCheckBox, {
                            key: 1,
                            list: __props.question.answerItems ? __props.question.answerItems : [],
                            value: value.value ? value.value : [],
                            readonly: time.value === 0 || __props.isAnswered,
                            callBackChange: callBackChange,
                            color: "white",
                            trueBgr: __props.isAnswered && !__props.exam?.autoDiagnosisEnabled ? '#bce0fd' : '#fff'
                          }, null, 8 /* PROPS */, ["list", "value", "readonly", "trueBgr"]))
                        : (__props.question.isRadio)
                          ? (_openBlock(), _createBlock(QuestionRadio, {
                              key: 2,
                              list: __props.question.answerItems ? __props.question.answerItems : [],
                              value: radioValue.value,
                              readonly: time.value === 0 || __props.isAnswered,
                              callBackChange: callBackChangeOne,
                              color: "white",
                              trueBgr: __props.isAnswered && !__props.exam?.autoDiagnosisEnabled ? '#bce0fd' : '#fff'
                            }, null, 8 /* PROPS */, ["list", "value", "readonly", "trueBgr"]))
                          : (__props.question.isSelect)
                            ? (_openBlock(), _createBlock(QuestionSelect, {
                                key: 3,
                                list: __props.question.answerItems ? __props.question.answerItems : [],
                                value: value.value ? value.value : [],
                                readonly: time.value === 0 || __props.isAnswered,
                                callBackChange: callBackChange,
                                color: "white",
                                trueBgr: __props.isAnswered && !__props.exam?.autoDiagnosisEnabled ? '#bce0fd' : '#fff'
                              }, null, 8 /* PROPS */, ["list", "value", "readonly", "trueBgr"]))
                            : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}
}

})